/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

// export const WrapperHeader = styled.div`
//   display: flex;
//   /* flex: 1; */
//   justify-content: space-between;
//   margin-top: 20px;

//   div {
//     display: flex;
//     flex-direction: row;
//     gap: 10px;
//   }

//   input {
//     width: 240px;
//     padding: 12px 14px;
//     border: 1px solid #d0d5dd;
//     border-radius: 10px;

//     font-size: 15px;
//     color: #101828;
//     background-color: #fff;

//     outline: none;
//     transition: all 0.2s ease;

//     box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
//   }

//   input::placeholder {
//     color: #98a2b3;
//   }

//   input:hover {
//     border-color: #98a2b3;
//   }

//   input:focus {
//     border-color: #6366f1;
//     box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
//   }
// `;

export const WrapperHeader = styled.div`
  display: flex;
  /* flex: 1; */
  justify-content: space-between;
  margin-top: 20px;

  div {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  input,
  select {
    width: 240px;
    padding: 12px 14px;
    border: 1px solid #d0d5dd;
    border-radius: 10px;

    font-size: 15px;
    color: #101828;
    background-color: #fff;

    outline: none;
    transition: all 0.2s ease;

    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  }

  input::placeholder {
    color: #98a2b3;
  }

  input:hover,
  select:hover {
    border-color: #98a2b3;
  }

  input:focus,
  select:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
  }

  select {
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    background-image: linear-gradient(45deg, transparent 50%, #667085 50%),
      linear-gradient(135deg, #667085 50%, transparent 50%);
    background-position: calc(100% - 20px) 50%, calc(100% - 14px) 50%;
    background-size: 6px 6px, 6px 6px;
    background-repeat: no-repeat;

    padding-right: 40px;
  }
`;

export const UploadButton = styled.button`
  border: none;
  background: #f3f4f6;
  color: #111827;
  margin-right: 20px;
  padding: 0 10px;
  border-radius: 5px;
  transition: 0.5s;
  cursor: pointer;
  transition: 0.2s ease;

  :hover {
    background: #d1d5db;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Title = styled.h2`
  color: #111827;
  padding: 10px 5px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  padding: 10px 5px;
`;

export const Card = styled.article`
  width: 100%;
  /* max-width: 420px; */
  /* background: #ffffff; */
  background: ${({ $updStatus }) =>
    $updStatus === 1 ? '#ecfdf5' : $updStatus === 2 ? '#fef2f2' : '##fff'};
  border-radius: 18px;
  padding: 24px;
  /* border: 1px solid #e5e7eb; */
  border: 1px solid
    ${({ $updStatus }) =>
      $updStatus === 1 ? '#10b981' : $updStatus === 2 ? '#ef4444' : '#e5e7eb'};
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.08);
  /* font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif; */
`;

export const Header = styled.header`
  margin-bottom: 10px;
`;

export const TitleCard = styled.h3`
  margin: 0;
  color: #1e293b;
  /* font-size: 22px; */
  font-weight: 700;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const SubtitleCard = styled.p`
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 12px;
`;

export const InfoList = styled.div`
  display: grid;
  gap: 5px;
  margin-bottom: 24px;
`;

export const InfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding: 6px 14px;
  /* border-radius: 5px; */
  /* background: #f8fafc; */
  border-bottom: 1px solid #e4e4e7;
`;

export const InfoLabel = styled.span`
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
`;

export const InfoValue = styled.span`
  /* color: #111827; */
  color: ${({ $updStatus }) =>
    $updStatus === 1 ? '#059669' : $updStatus === 2 ? '#dc2626' : '#111827'};
  font-size: 14px;
  font-weight: 700;
  text-align: right;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const Button = styled.button`
  flex: 1;
  max-width: 150px;
  border: none;
  border-radius: 5px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s ease;

  color: ${({ variant }) => (variant === 'approve' ? '#ffffff' : '#b91c1c')};
  background: ${({ variant }) =>
    variant === 'approve' ? '#16a34a' : '#fee2e2'};

  &:hover {
    transform: translateY(-1px);
    background: ${({ variant }) =>
      variant === 'approve' ? '#15803d' : '#fecaca'};
  }

  &:active {
    transform: translateY(0);
  }
`;
